export default __webpack_public_path__ + "static/media/fdxvalogo.163a7c33.png";